exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resizable[data-v-5740943d]{resize:both;overflow:hidden;padding:10px}.resizable[data-v-5740943d]:hover{border:1px dotted #000;-webkit-box-shadow:2px 2px 20px;box-shadow:2px 2px 20px}", ""]);

// exports
